import actions from './actions';
// eslint-disable-next-line import/no-named-as-default
import mutations from './mutations';
import getters from './getters';

const jobsModule = {
  namespaced: true,
  state() {
    return {
      currentJob: {},
      jobProgressTasks: [],
      editingFieldsByRow: {},
    };
  },
  actions,
  mutations,
  getters,
};

export default jobsModule;
